import { gql as graphql, TypedDocumentNode } from '@apollo/client/core';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
declare function typedGQLTag<Result, Variables>(
    literals: ReadonlyArray<string> | Readonly<string>,
    ...placeholders: any[]
): TypedDocumentNode<Result, Variables>;

export const gql: typeof typedGQLTag = graphql;
